import { type NavigateOptions } from "react-router-dom";
import { AppRoutes } from "@/infra/router";
import { loggerService } from "@akina/infra";

function handleDeepLinkNavigation(
  navigate: (path: string, options?: { replace?: boolean }) => void,
  handleDeepLink: (callback?: () => void) => void,
  path: string,
  trigger: string,
) {
  handleDeepLink(() => {
    loggerService.info(`Navigating to route - TRIGGER: ${trigger} - PATH: ${path}`);
    navigate(path, { replace: true });
  });
}

function handleDeepLinkHomeRedirect(
  navigate: (path: string, options?: { replace?: boolean }) => void,
  handleDeepLink: (callback?: () => void) => void,
  trigger: string,
) {
  handleDeepLink(() => {
    loggerService.info(`Navigating to home - TRIGGER: ${trigger}`);
    navigate(AppRoutes.Home, { replace: true });
  });
}

function attemptDeepLinkNavigation(
  navigate: (path: string, options?: NavigateOptions) => void,
  handleDeepLink: (callback?: () => void) => void,
  url: string,
) {
  if (!url) return handleDeepLinkHomeRedirect(navigate, handleDeepLink, "Deep link opened but no URL was found");

  const path = url.replace(/^akina-care:?\/?\/?/, "");
  if (path) handleDeepLinkNavigation(navigate, handleDeepLink, path, "Deep link opened with path: " + path);
  else handleDeepLinkHomeRedirect(navigate, handleDeepLink, "Deep link opened but no path was found");
}

export { attemptDeepLinkNavigation,  handleDeepLinkHomeRedirect };
